export const environment = {
  production: false,
  apiUrl: 'https://apidev.gridxum.com/api/v1',
};
